<template>
	<div class="wrapper">
		<headerTag />
		<div class="aboutBanner">
			<img src="../../assets/images/about/banner.png" alt=""/>
			<img src="../../assets/images/about/banner_txt1.png" alt=""/>
			<img src="../../assets/images/about/banner_txt2.png" alt=""/>
		</div>
		<div class="aboutCon aboutCon1">
			<img src="../../assets/images/about/tips1.png" alt="" class="aboutTips" />
			<p class="aboutCon-txt">
				零分享隶属于上海蜜瓣网络科技有限公司，致力于为电商企业提供全面贴心的一站式服务。
				拥有丰富行业经验的专业团队，业务范围涵盖公司注册、企业变更、代理记账、天猫主体变更、电商税务筹划、天猫店铺交易安全咨询、淘宝升级企业店铺等各类需求。
				我们充分考虑每个细节想其所需，坚持诚信高效为首要原则，为客户提供全程优质体验，
				并针对电商客户群体不断开拓更多元化的服务和市场。
			</p>
		</div>
		<div class="aboutCon aboutCon2">
			<img src="../../assets/images/about/tips2.png" alt="" class="aboutTips" />
			<div class="about-service">
				<div>
					<img src="../../assets/images/about/about_icon1.png" alt=""/>
					<p>专业团队支持</p>
					<p>丰富行业经验</p>
				</div>
				<div>
					<img src="../../assets/images/about/about_icon2.png" alt=""/>
					<p>企业需求导向</p>
					<p>精准方案策划</p>
				</div>
				<div>
					<img src="../../assets/images/about/about_icon3.png" alt=""/>
					<p>多元增值服务</p>
					<p>满足全面需求</p>
				</div>
				<div>
					<img src="../../assets/images/about/about_icon4.png" alt=""/>
					<p>全程收费透明</p>
					<p>诚信可靠安心</p>
				</div>
			</div>
		</div>
		<div class="aboutCon aboutCon3">
			<img src="../../assets/images/about/tips3.png" alt="" class="aboutTips" />
			<div class="aboutTab" id="aboutSwiper">
				<div class="swiper-wrapper">
				    <div class="swiper-slide">
						<span @click="cur=0" :class="{active:cur==0}">上海</span>
					</div>
					<div class="swiper-slide">
						<span @click="cur=1" :class="{active:cur==1}">杭州</span>
					</div>
					<div class="swiper-slide">
						<span @click="cur=2" :class="{active:cur==2}">深圳</span>
					</div>
					<div class="swiper-slide">
						<span @click="cur=3" :class="{active:cur==3}">广州</span>
					</div>
					<div class="swiper-slide">
						<span @click="cur=4" :class="{active:cur==4}">东莞</span>
					</div>
				
					
					<div class="swiper-slide">
						<span @click="cur=6" :class="{active:cur==6}">义乌</span>
					</div>
					<div class="swiper-slide">
						<span></span>
					</div>
				</div>
				<!-- Add Arrows -->
				<div class="swiper-button-next">
					 <img style="width:100%;height:100%" src="../../assets/images/about/right.png" alt/>
				</div>
			</div>
			<div class="aboutTab-main">
				<div v-show="cur==0">
					<p>
						<img src="../../assets/images/about/user.png" alt=""/>
						<span>纪经理</span>
					</p>
					<p>
						<img src="../../assets/images/about/phone.png" alt=""/>
						<span><a href="tel:15900662618">15900662618</a></span>
					</p>
					<p>
						<img src="../../assets/images/about/location.png" alt=""/>
						<span>上海市闵行区顾戴路2337号维璟中心（原丰树商业城）B幢17楼</span>
					</p>
				</div>
				<div v-show="cur==1">
					<p>
						<img src="../../assets/images/about/user.png" alt=""/>
						<span>陈经理</span>
					</p>
					<p>
						<img src="../../assets/images/about/phone.png" alt=""/>
						<span><a href="tel:17521679829">17521679829</a></span>
					</p>
					<p>
						<img src="../../assets/images/about/location.png" alt=""/>
						<span>杭州市萧山区市心北路1929号万和国际7幢705</span>
					</p>
				</div>
				<div v-show="cur==2">
					<p>
						<img src="../../assets/images/about/user.png" alt=""/>
						<span>马经理</span>
					</p>
					<p>
						<img src="../../assets/images/about/phone.png" alt=""/>
						<span><a href="tel:15915806059">15915806059</a></span>
					</p>
					<p>
						<img src="../../assets/images/about/location.png" alt=""/>
						<span>深圳市龙华区民康路284号东明大厦528</span>
					</p>
				</div>
				<div v-show="cur==3">
					<p>
						<img src="../../assets/images/about/user.png" alt=""/>
						<span>赵经理</span>
					</p>
					<p>
						<img src="../../assets/images/about/phone.png" alt=""/>
						<span><a href="tel:18665695265">18665695265</a></span>
					</p>
					<p>
						<img src="../../assets/images/about/location.png" alt=""/>
						<span>广州市天河区燕岭路585号世创智谷222室</span>
					</p>
				</div>
				<div v-show="cur==4">
					<p>
						<img src="../../assets/images/about/user.png" alt=""/>
						<span>林经理</span>
					</p>
					<p>
						<img src="../../assets/images/about/phone.png" alt=""/>
						<span><a href="tel:13641434521">13641434521</a></span>
					</p>
					<p>
						<img src="../../assets/images/about/location.png" alt=""/>
						<span>东莞市厚街镇体育路27号建科大厦1006</span>
					</p>
				</div>
			
				
				<div v-show="cur==6">
					<p>
						<img src="../../assets/images/about/user.png" alt=""/>
						<span>王经理</span>
					</p>
					<p>
						<img src="../../assets/images/about/phone.png" alt=""/>
						<span><a href="tel:13754319991">13754319991</a></span>
					</p>
					<p>
						<img src="../../assets/images/about/location.png" alt=""/>
						<span>浙江省金华市义乌市北苑街道望道路328号跨界园三区6楼643号</span>
					</p>
				</div>
			</div>
		</div>
		<div class="bottomDiv clear">
				<p>
					<a href="//www.lingfenxiang.com?pc">电脑端</a>
					<router-link  :to="{ name:'aboutPage'}" >
						关于我们
					</router-link>
					<router-link  :to="{ name:'zixunPage'}" >
						行业资讯
					</router-link>
				</p>
				<p>Copyright © 2011-{{currYear}} 沪ICP备18035332号-2</p>
				<p>上海蜜瓣网络科技有限公司 版权所有</p>
			</div>
		</div>
	</div>

</template>

<script>
    import Swiper from 'swiper'
    import "../../assets/css/about.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    
    export default {
    	name: 'aboutPage',
    	data(){
    	    return{
    	        cur:0,
				currYear:new Date().getFullYear(),
			}
		},
    	components: {
    		headerTag,
    	},
		mounted(){
			var aboutSwiper = new Swiper('#aboutSwiper', {
				    slidesPerView: 5.5,
					centeredSlides : false,
					navigation: {
					  nextEl: '.swiper-button-next',
					}
			});
		}
    }
</script>


